export const REQUEST_ROBOTS_PENDING: string = "REQUEST_ROBOTS_PENDING";
export const REQUEST_ROBOTS_SUCCESS: string = "REQUEST_ROBOTS_SUCCESS";
export const REQUEST_ROBOTS_FAILED: string = "REQUEST_ROBOTS_FAILED";

export interface IRobot {
  id: number;
  name: string;
  email: string;
}

export interface IRobotState {
  items: Array<IRobot>;
  isPending: boolean;
  error: string;
}

export interface IRequestRobotsPendingAction {
  type: typeof REQUEST_ROBOTS_PENDING;
}

export interface IRequestRobotsSuccessAction {
  type: typeof REQUEST_ROBOTS_SUCCESS;
  payload: Array<IRobot>;
}

export interface IRequestRobotsFailedAction {
  type: typeof REQUEST_ROBOTS_FAILED;
  payload: string;
}

export type RobotActionTypes =
  | IRequestRobotsPendingAction
  | IRequestRobotsSuccessAction
  | IRequestRobotsFailedAction;
